module.exports = __webpack_public_path__ + "647aa345e4a58caa0425adaf5be09075.svg";